import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { descMaxLength, getHourSlots, nameMaxLength } from '../../Constant.js'
import axios from 'axios'
import ImageCropper from '../../common/ImageCropper/ImageCropper.js'
import ReactQuill from 'react-quill'

class CarCompanyAdd extends React.Component {
  state = {
    is_active: 'true',
    name_en: '',
    name_ar: '',
    img_url_en: '',
    img_url_ar: '',
    description_en: '',
    description_ar: '',
    minimum_booking_time: '',
    start_time: '',
    end_time: '',
    user_id: '',
    isSaving: false,
    isData: false,
    Edit: false,
    companyEditAr: false,

    b2c_commission_type: '',
    b2b_commission_type: '',
    b2b_commission: '',
    b2c_commission: '',
    cancelation_policy_en: '',
    cancelation_policy_ar: '',
  }

  componentDidMount() {
    if (this.props?.company_id) {
      this.getCompanyDetails()
    }
    this.getCarOwners()
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleChangeImage = (e, imgKeyName) => {
    this.setState({
      [imgKeyName]: e,
      Edit: false,
    })
  }

  onSave = () => {
    var that = this

    if (this.state.b2b_commission_type && (!this.state.b2b_commission || this.state.b2b_commission == 0)) {
      document.getElementById('b2b_commission')?.focus()
      that.setState({ isData: false })
      Swal.fire({
        title: 'B2B commission is required',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    if (this.state.b2c_commission_type && (!this.state.b2c_commission || this.state.b2c_commission == 0)) {
      document.getElementById('b2c_commission')?.focus()
      that.setState({ isData: false })
      Swal.fire({
        title: 'B2C commission is required',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }

    const formData = new FormData()
    formData.append('name_en', this.state.name_en)
    formData.append('user_id', this.state.user_id === 'no_owner' ? '' : this.state.user_id?.toString())
    formData.append('name_ar', this.state.name_ar)
    formData.append('description_en', this.state.description_en)
    formData.append('description_ar', this.state.description_ar)
    formData.append('is_active', this.state.is_active)

    formData.append('b2b_commission_type', this.state.b2b_commission_type || '')
    formData.append('b2b_commission', this.state.b2b_commission || '')
    formData.append('b2c_commission_type', this.state.b2c_commission_type || '')
    formData.append('b2c_commission', this.state.b2c_commission || '')
    formData.append('cancelation_policy_en', this.state.cancelation_policy_en)
    formData.append('cancelation_policy_ar', this.state.cancelation_policy_ar)

    if (this.state.start_time) {
      formData.append('start_time', this.state.start_time)
    }
    if (this.state.end_time) {
      formData.append('end_time', this.state.end_time)
    }
    if (this.state.minimum_booking_time) {
      formData.append('minimum_booking_time', this.state.minimum_booking_time)
    }

    if (this.props.company_id) {
      that.setState({ isData: true })
      formData.append('id', this.props.company_id)
      if (this.state.img_url_en?.type) {
        formData.append('img_url_en', this.state.img_url_en, 'your_original_filename.jpeg')
      }
      if (this.state.img_url_ar?.type) {
        formData.append('img_url_ar', this.state.img_url_ar, 'your_original_filename.jpeg')
      }
      axios
        .put(Constant.getAPI() + '/car/update-car-company', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Company has been Updated`, 'success')
            window.location.href = `#/car-company`
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      that.setState({ isData: true })
      if (this.state.img_url_en?.type) {
        formData.append('img_url_en', this.state.img_url_en, 'your_original_filename.jpeg')
      }
      if (this.state.img_url_ar?.type) {
        formData.append('img_url_ar', this.state.img_url_ar, 'your_original_filename.jpeg')
      }
      axios
        .post(Constant.getAPI() + '/car/create-car-company', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          that.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Company has been Added`, 'success')
            window.location.href = `#/car-company`
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  getCompanyDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/car/get-car-company/${this.props.company_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            ...res?.data?.data,
          })
          this.setState({
            Edit: true,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getCarOwners = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + '/admin/list-users/car-owner', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          that.setState({
            carOwnerList: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Company Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_en"
                    id="name_en"
                    placeholder=" Company Name: English"
                    onChange={this.handleChange}
                    value={this.state.name_en}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.name_en ? this.state.name_en.length + ' / ' + nameMaxLength : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Company Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_ar"
                    id="name_ar"
                    placeholder="Company Name: Arabic"
                    onChange={this.handleChange}
                    value={this.state.name_ar}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.name_ar ? this.state.name_ar.length + ' / ' + nameMaxLength : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Company Description: English</label>
                <div className="col-sm-9">
                  <textarea
                    rows={4}
                    className="form-control"
                    name="description_en"
                    id="description_en"
                    placeholder="Description Name: English"
                    value={this.state.description_en}
                    onChange={this.handleChange}
                  />
                  <div className="col-sm-12 text-right">
                    {this.state.description_en
                      ? this.state.description_en.length + ' / ' + descMaxLength
                      : 0 + ' / ' + descMaxLength}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Company Description: Arabic</label>
                <div className="col-sm-9">
                  <textarea
                    rows={4}
                    className="form-control"
                    name="description_ar"
                    id="description_ar"
                    placeholder="Description Name: English"
                    value={this.state.description_ar}
                    onChange={this.handleChange}
                  />
                  <div className="col-sm-12 text-right">
                    {this.state.description_ar
                      ? this.state.description_ar.length + ' / ' + descMaxLength
                      : 0 + ' / ' + descMaxLength}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Car Owner</label>
                <div className="col-sm-9">
                  <select
                    name="user_id"
                    className="form-control"
                    value={this.state.user_id}
                    onChange={this.handleChange}
                  >
                    <option value="no_owner">No Owner</option>
                    {this.state.carOwnerList !== undefined &&
                      this.state.carOwnerList !== null &&
                      this.state.carOwnerList !== [] &&
                      this.state.carOwnerList.length > 0
                      ? this.state.carOwnerList?.map((carOwnerList) => (
                        <option
                          value={carOwnerList?.id}
                          key={carOwnerList?.id}
                        >
                          {carOwnerList?.first_name}
                          {carOwnerList?.last_name}
                        </option>
                      ))
                      : null}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Minimum Booking Time</label>
                <div className="col-sm-9">
                  <select
                    name="minimum_booking_time"
                    className="form-control"
                    value={this.state.minimum_booking_time}
                    onChange={this.handleChange}
                  >
                    <option>Select time(HH:MM)</option>
                    {getHourSlots().map((itm) => (
                      <option value={itm.value}>{itm.label}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Start Time</label>
                <div className="col-sm-9">
                  <select
                    name="start_time"
                    className="form-control"
                    value={this.state.start_time}
                    onChange={this.handleChange}
                  >
                    <option>Select Start time(HH:MM)</option>
                    {getHourSlots().map((itm) => (
                      <option value={itm.value}>{itm.label}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">End Time</label>
                <div className="col-sm-9">
                  <select
                    name="end_time"
                    className="form-control"
                    value={this.state.end_time}
                    onChange={this.handleChange}
                  >
                    <option>Select End time(HH:MM)</option>
                    {getHourSlots().map((itm) => (
                      <option value={itm.value}>{itm.label}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Commission</div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2B Commission Type</label>
                <div className="col-sm-9">
                  <select
                    name="b2b_commission_type"
                    className="form-control"
                    value={this.state.b2b_commission_type}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Option</option>
                    <option value="percentage">Percentage</option>
                    <option value="amount">Amount</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2B Commission</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="b2b_commission"
                    id="b2b_commission"
                    // placeholder="In percentage 1 to 100"
                    value={this.state.b2b_commission}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2C Commission Type</label>
                <div className="col-sm-9">
                  <select
                    name="b2c_commission_type"
                    className="form-control"
                    value={this.state.b2c_commission_type}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Option</option>
                    <option value="percentage">Percentage</option>
                    <option value="amount">Amount</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2C Commission</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="b2c_commission"
                    id="b2c_commission"
                    // placeholder="In percentage 1 to 100"
                    value={this.state.b2c_commission}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Policy</div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Cancellation Policy: English</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="cancelation_policy_en"
                    id="cancelation_policy_en"
                    value={this.state.cancelation_policy_en}
                    onChange={(value) => {
                      this.setState({
                        cancelation_policy_en: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Cancellation Policy: Arabic</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="cancelation_policy_ar"
                    id="cancelation_policy_ar"
                    value={this.state.cancelation_policy_ar}
                    onChange={(value) => {
                      this.setState({
                        cancelation_policy_ar: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="is_active"
                    className="form-control"
                    value={this.state.is_active}
                    onChange={this.handleChange}
                  >
                    <option
                      value="true"
                      name=""
                    >
                      Active
                    </option>
                    <option
                      value="false"
                      name=""
                    >
                      Inactive
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <ImageCropper
                        ratio={1 / 1}
                        img={this.state.img_url_en || null}
                        onChange={(e) => {
                          this.handleChangeImage(e, 'img_url_en')
                        }}
                      ></ImageCropper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image: Arabic</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <ImageCropper
                        ratio={1 / 1}
                        img={this.state.img_url_ar || null}
                        onChange={(e) => {
                          this.handleChangeImage(e, 'img_url_ar')
                        }}
                      ></ImageCropper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button className="btn btn-grd-disabled mr-2">Saving...!</button>
            ) : (
              <button
                onClick={this.onSave}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}

            <Link
              to={`/car-company`}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default CarCompanyAdd
